import React, { useState } from 'react';

import { useMutation } from 'react-query';
import { AuthServiceInstance } from 'services/authService';
import { AllErrors } from 'types/Errors';
import { UpdatePasswordPayload } from 'types/services/Auth';

import { ProfileGeneratedProps } from './Profile.props';
import ProfileView from './Profile.view';

const Profile = (): JSX.Element => {
  // MARK:- State
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // MARK:- Mutations
  const updatePasswordMutation = useMutation(
    AuthServiceInstance.updatePassword,
    {
      onSuccess: () => {
        setSuccess('Password Updated!');
      },
      onError: (error: AllErrors) => {
        setError(error.message);
      },
    }
  );

  // MARK:- Functions
  function onSubmit(form: UpdatePasswordPayload) {
    updatePasswordMutation.mutate(form);
  }

  function onSubmitFailed() {
    // TODO:-
  }

  // MARK:- Render
  const generatedProps: ProfileGeneratedProps = {
    onSubmit,
    onSubmitFailed,
    isSubmitting: updatePasswordMutation.isLoading,
    error,
    success,
  };
  return <ProfileView {...generatedProps} />;
};

export default Profile;
